import { useState } from "react";
import { FoundryTechLineWorkspace } from "./FoundryTechLineWorkspace";

type AnalysisTab = "techline";

const tabs: Array<{ id: AnalysisTab; label: string; description: string }> = [
  {
    id: "techline",
    label: "Techline Intelligence",
    description: "Find recurring technical questions and turn them into coaching opportunities.",
  },
];

export function FoundryAnalysisWorkspace() {
  const [activeTab, setActiveTab] = useState<AnalysisTab>("techline");

  return (
    <section aria-label="Palantir Foundry Analysis" className="space-y-5">
      <header className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-[var(--accent)]">Palantir Foundry</p>
          <h1 className="mt-1 text-2xl font-semibold">Palantir Foundry Analysis</h1>
          <p className="mt-1 max-w-2xl text-sm text-[var(--ink-soft)]">Review the operational insights Foundry produces from WorkView Pro data.</p>
        </div>
        <span className="rounded-full bg-[var(--wash)] px-3 py-1 text-xs font-medium text-[var(--ink-soft)]">Admin-only</span>
      </header>

      <div className="border-b border-[var(--line)]" role="tablist" aria-label="Foundry analysis sections">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            id={`foundry-tab-${tab.id}`}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`foundry-panel-${tab.id}`}
            onClick={() => setActiveTab(tab.id)}
            className={`border-b-2 px-1 pb-3 text-sm font-semibold transition ${activeTab === tab.id ? "border-[var(--accent)] text-[var(--accent)]" : "border-transparent text-[var(--ink-soft)] hover:text-[var(--ink)]"}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div id={`foundry-panel-${activeTab}`} role="tabpanel" aria-labelledby={`foundry-tab-${activeTab}`}>
        <p className="mb-5 text-sm text-[var(--ink-soft)]">{tabs.find((tab) => tab.id === activeTab)?.description}</p>
        {activeTab === "techline" && <FoundryTechLineWorkspace />}
      </div>
    </section>
  );
}
